<template>
  <section
    :id="`${cms.scroll_id}`"
    v-editable="cms"
    :class="[name, spacing]"
    :style="mainCssVars"
  >
    <grid
      :class="['grid--container', `${name}__grid`]"
      :layout="[
        {
          size: 1,
          columns: 'repeat(12, 1fr)',
          gap: '6px',
        },
        {
          size: 2,
          columns: 'repeat(24, 1fr)',
          gap: '10px',
        },
      ]"
    >
      <grid-item
        :class="[`${name}__grid-item`, `${name}__content`]"
        :layout="[
          { size: 1, x: 1, width: 12 },
          { size: 3, x: 1, width: 9 },
        ]"
      >
        <a-copy :cms="cms" />
      </grid-item>
      <grid-item
        :class="[`${name}__grid-item`, `${name}__contacts`]"
        :layout="[
          { size: 1, x: 1, width: 12 },
          { size: 3, x: 10, width: 15 },
        ]"
      >
        <div :class="`${name}__collection`">
          <div
            v-for="item in cms.contacts"
            :key="item._uid"
            v-editable="item"
            :class="`${name}__item`"
          >
            <a-eyebrow
              v-if="item.eyebrow"
              :cms="item"
              :class="`${name}__collection-eyebrow`"
            />
            <a-image-v2
              v-if="(item.image || {}).filename"
              :src="(item.image || {}).filename"
              :alt="(item.image || {}).alt"
              :layout="[{ size: 0, bound: 207, ratio: [207, 207] }]"
              :class="`${name}__collection-image`"
            />
            <a-heading
              v-if="item.heading"
              :cms="item"
              html-tag="h4"
              :class="`${name}__collection-heading`"
            />
            <!-- eslint-disable vue/no-v-html -->
            <div
              v-if="item.copy"
              :class="`${name}__collection-text`"
              v-html="$options.filters.markdown(item.copy)"
            />
            <!--eslint-enable-->
          </div>
        </div>
      </grid-item>
    </grid>
  </section>
</template>

<script>
import Colors from '~/mixins/colors'
import data from '~/components/organisms/o-article-v2/o-article-v2.data'

export default {
  mixins: [Colors],
  props: {
    cms: {
      type: Object,
      default() {
        const config = {}
        return process.env.NODE_ENV === 'development'
          ? { ...data, ...config }
          : config
      },
    },
  },

  data() {
    return {
      name: 'o-contact-leads-v2',
    }
  },

  computed: {
    spacing() {
      return this.cms.spacing
    },
    mainCssVars() {
      return {
        '--bg-color': this.setColor(
          (this.cms.color_background || {}).color || '#000000',
          this.cms.color_gradient
        ),
        '--text-color': this.setColor(
          (this.cms.color_text || {}).color || '#FFFFFF'
        ),
        '--hover-color': this.setColor(
          (this.cms.color_hover || {}).color || '#C33CA8'
        ),
        '--disabled-color': this.setColor(
          (this.cms.color_disabled || {}).color || '#888b8d'
        ),
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.o-contact-leads-v2 {
  transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out,
    border 0.2s ease-in-out;
  background: var(--bg-color);
  border-color: var(--text-color);
  color: var(--text-color);
  padding: 100px 0;

  ::v-deep a,
  ::v-deep .a-cta {
    color: var(--text-color);
    &:hover,
    &:active {
      color: var(--hover-color);
    }
    &:disabled,
    &.disabled {
      color: var(--disabled-color);
    }
  }

  &__grid {
    align-items: center;
  }

  &__collection {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    justify-items: stretch;
  }

  &__item {
    margin: 15px;
  }

  &__collection-image {
    ::v-deep img {
      margin-bottom: 30px;
    }
  }

  &__collection-heading {
    @include font-size(16, 25.2px);

    margin: 0;
  }

  &__collection-text {
    ::v-deep p {
      margin: 0;
    }
  }
}

@include media-breakpoint-up(md) {
  .o-contact-leads-v2 {
    &__collection {
      border-left: 1px solid $mine-shaft;
      padding-left: 30px;
    }
  }
}

@include media-breakpoint-up(lg) {
  .o-contact-leads-v2 {
    &__collection {
      grid-template-columns: repeat(3, 1fr);
    }
  }
}
</style>
